import { db } from '../Index';

// Verifica se os dados obtidos em um GET estão atualizados com o BD local

type DataType =
  | 'propriedades'
  | 'animais'
  | 'pesquisaAnimais'
  | 'usuarios'
  | 'filtrosValidos'
  | 'registros';

export async function ManterAtualizado(dataType: DataType, data: any) {
  const currentData = await db
    .table(dataType)
    .where('id')
    .equals(data.id)
    .toArray();

  try {
    if (currentData[0]) {
      const isUpdated = currentData[0].updated_at === data.updated_at;

      if (!isUpdated) {
        await db.table(dataType).delete(data.id);
        await db.table(dataType).add(data);
        //console.log(`Item de ${dataType} atualizado`);
      }

      if (dataType === 'propriedades') {
        await db.table(dataType).delete(data.id);
        await db.table(dataType).add(data);
      }
    } else {
      await db.table(dataType).add(data);
      //console.log(`Item de ${dataType} criado`);
    }
  } catch (err) {
    console.log(err);
  }
}
